export const V_URL_API =
  window.location.origin ===
  "https://443--main--devcloudih--eliud-g-env.cloudih.io"
    ? "https://8003--main--env-saiprog--saiprog-env.cloudih.io"
    : window.location.origin;

    export const V_URL_API_WS =
    window.location.host ===
  "443--main--devcloudih--eliud-g-env.cloudih.io"
    ? "8003--main--env-saiprog--saiprog-env.cloudih.io"
    : window.location.host;

// Array de enlaces de imágenes
const images = [
  "https://img.freepik.com/foto-gratis/fondo-papel-tapiz-azul-arte-abstracto-textura-colores-mezclados_53876-134381.jpg?w=300",
  "https://img.freepik.com/foto-gratis/papel-tapiz-fondo-pintura-azul-arte-abstracto-textura-colores-mezclados_53876-134380.jpg?w=300",
  "https://img.freepik.com/foto-gratis/papel-tapiz-fondo-rojo-textura-pintura-acrilica-espacio-blanco_53876-133258.jpg?w=300",
  "https://img.freepik.com/foto-gratis/fondo-pantalla-neon-textura-pintura-abstracta-colores-mezclados_53876-133260.jpg?w=300",
  "https://img.freepik.com/foto-gratis/papel-tapiz-fondo-rosa-textura-pintura-abstracta-colores-mezclados_53876-142835.jpg?w=300",
  "https://img.freepik.com/foto-gratis/fondo-pantalla-textura-pintura-arte-abstracto-colores-mezclados_53876-142836.jpg?w=300",
];

// Función para obtener una imagen aleatoria
export function getRandomImage() {
  const randomIndex = Math.floor(Math.random() * images.length);
  return images[randomIndex];
}
